module.exports = require("core-js/library/fn/array/from");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/array/from.js
 ** module id = 334
 ** module chunks = 0
 **/